import { useEffect, useState } from "react";
import { loadGoogleMaps } from "@/lib/googleMaps";

// Shared across every MapCanvas instance on the page — the underlying script
// load is deduped in loadGoogleMaps(), this hook just gives each component
// its own render-triggering state for when that single load resolves.
export function useGoogleMaps() {
  const [state, setState] = useState(() => ({ maps: window.google?.maps || null, error: null }));

  useEffect(() => {
    if (state.maps) return;
    let alive = true;
    loadGoogleMaps()
      .then((maps) => { if (alive) setState({ maps, error: null }); })
      .catch((error) => { if (alive) setState({ maps: null, error }); });
    return () => { alive = false; };
  }, [state.maps]);

  return state;
}
